export const formProps = {
    width: {
        base: "100%",
        md: "50%",
        lg: "30%"
    }
}